import React from "react";
import { Plus, Inbox } from "lucide-react";
import { Button } from "./ui/button";
import SetupDetailView from "./SetupDetailView";
import PortfolioStatsBar from "./PortfolioStatsBar";
import SetupCards from "./SetupCards";
import AlertsPanel from "./AlertsPanel";

export default function Dashboard({ setups, selectedId, onSelect, onAddSetup, onEditSetup, onRefresh }) {
  if (setups.length === 0) {
    return <EmptyState onAdd={onAddSetup} />;
  }

  return (
    <div className="flex flex-col min-h-full" data-testid="dashboard-page">
      {/* Portfolio stats bar — always visible */}
      <PortfolioStatsBar setups={setups} />

      <div className="p-4 md:p-6 space-y-4 max-w-full overflow-x-hidden">
        {/* Active alerts panel */}
        <AlertsPanel setups={setups} />

        {/* Main content */}
        {selectedId ? (
          <SetupDetailView
            setupId={selectedId}
            onDeleted={() => onRefresh?.()}
            onChanged={() => onRefresh?.()}
            onEdit={onEditSetup}
            embedded
          />
        ) : (
          <SetupCards setups={setups} onSelect={onSelect} />
        )}
      </div>
    </div>
  );
}

function EmptyState({ onAdd }) {
  return (
    <div className="border border-dashed border-zinc-800 p-12 text-center mx-auto max-w-2xl mt-8" data-testid="empty-state">
      <Inbox size={48} className="mx-auto text-zinc-700 mb-4" strokeWidth={1} />
      <h3 className="font-display font-bold text-2xl mb-2">Willkommen im Friedrich Allocation Hub</h3>
      <p className="text-zinc-500 text-sm mb-6 max-w-md mx-auto leading-relaxed">
        Füge dein erstes Setup hinzu — entweder per Friedrich-Report URL, durch Einfügen einer E-Mail
        oder manuell. KI extrahiert Zonen, Targets und Stop-Loss automatisch.
      </p>
      <Button
        onClick={onAdd}
        className="bg-white text-black hover:bg-zinc-200 rounded-sm font-display font-bold uppercase tracking-wider"
        data-testid="btn-empty-add"
      >
        <Plus size={14} className="mr-1" /> Erstes Setup anlegen
      </Button>
    </div>
  );
}
